<template>
  <v-app class="app-style">
    <v-app-bar class="app-bar gradient-color-primary" elevation="4" app>
      <v-app-bar-nav-icon @click="handleDrawer"></v-app-bar-nav-icon>
      <v-toolbar-title>LeadTable Admin Panel</v-toolbar-title>
    </v-app-bar>
    <div class="search-field-wrapper">
      <div style="position: relative">
        <v-text-field
          single-line
          density="compact"
          variant="solo"
          class="search-field"
          label="Agentursuche"
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          rounded="lg"
          hint="Name, Email, Domain & ID"
        ></v-text-field>
        <v-progress-circular
          indeterminate
          small
          color="primary"
          :style="{ position: 'absolute', top: '10%', right: '5%' }"
          v-if="searchLoading"
        ></v-progress-circular>
      </div>
      <div
        class="result-wrapper"
        v-for="result in searchResults"
        :key="result._id"
      >
        <v-btn
          class="search-field-results-buttons"
          @click="openAgencyDialog(result)"
          >{{ result.style.companyName }}</v-btn
        >
      </div>
    </div>
    <v-navigation-drawer
      v-model="drawer"
      class="gradient-color-primary"
      app
      elevation="4"
    >
      <div style="display: flex; flex-direction: column; height: 100%">
        <v-list dense style="flex: 1">
          <v-list-item
            :to="item.route"
            link
            v-for="(item, index) in menuItems"
            :key="index"
            active-class="deep-purple--text text--accent-4"
          >
            <v-list-item-title
              ><v-icon class="mr-2" left>{{ item.icon }}</v-icon
              >{{ item.title }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list-item @click="logout">
          <v-list-item-title
            ><v-icon class="mr-2" left>mdi-logout</v-icon
            >Logout</v-list-item-title
          >
        </v-list-item>
      </div>
    </v-navigation-drawer>

    <v-main class="main-style">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import _ from "lodash"; // Ensure lodash is installed for debouncing

export default {
  components: {
  },
  computed: {
    ...mapGetters("search", ["searchResults", "searchLoading"]),
  },
  data() {
    return {
      drawer: false,
      group: null,
      menuItems: [
        { title: "Dashboard", icon: "mdi-view-dashboard", route: "/" },
        { title: "Support", icon: "mdi-lifebuoy", route: "/support" },
        { title: "Marketing", icon: "mdi-chart-bubble", route: "/marketing" },
        { title: "Statistics", icon: "mdi-chart-bar", route: "/statistics" },
      ],
      searchQuery: "",
      selectedAgency: null,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("loginAndOut/logout");
      this.$router.push("/login");
    },
    ...mapActions("search", ["search"]),
    ...mapMutations("agency", ["setDialogReturnRoute"]),
    openAgencyDialog(agency) {
      this.searchQuery = "";
      this.$store.dispatch("search/resetSearchResults");
      this.selectedAgency = agency;
      this.$store.commit("agency/setDialogReturnRoute", this.$route.fullPath);
      this.$router.push({
        name: "agency",
        params: { agencyId: this.selectedAgency._id },
      });
    },
    handleDrawer() {
      this.drawer = !this.drawer;
    },
    debouncedSearch: _.debounce(function (newQuery) {
      if (newQuery) {
        this.$store.dispatch("search/search", newQuery);
      }
    }, 500),
  },
  watch: {
    searchQuery(newQuery) {
      this.debouncedSearch(newQuery);
    },
  },
};
</script>

<style>
.main-style {
  padding-top: 0px !important;
}

.app-bar {
  display: flex;
  justify-content: space-between;
  max-height: 64px;
  width: 600px;
  max-width: 25%;
  border-bottom-right-radius: 18px;

  @media screen and (max-width: 600px) {
    max-width: 68px;
  }
}

.search-field-wrapper {
  position: relative;
  width: 50%;
  max-width: 400px;
  margin: 12px 48px auto auto;
  height: 100%;
  max-height: 64px;
  z-index: 9;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.search-field {
  margin-top: 4px;
  width: 100%;

  @media screen and (max-width: 600px) {
    width: 50%;
    margin-left: auto;
    margin-right: auto;
  }
}

.result-wrapper {
  position: static;
  top: 100%;
  width: 100%;
  max-width: 400px;
  z-index: 1000;
  background-color: white;

  @media screen and (max-width: 600px) {
    margin-top: 12px;
  }
}

.search-field-results-buttons {
  padding: 8px;
  margin-top: 4px;
  width: 100%;
  max-width: 400px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  text-transform: none !important;
}
</style>
